import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ITool } from '@atredux/slices/toolSlice'

interface IBaseConfig {
    displayName?: string
    displayNameStringId?: string
    name?: string
    translateID?: string
}

export type IZone = IBaseConfig & {
    zoneName: string
    zoneDisplayName: string
    subzones: ISubzone[],
}

export type ISubzone = IBaseConfig & {
    subzoneName: string
    subzoneDisplayName: string
    tools: ITool[],
}

export interface IZoneState {
    zoneName: string
    subzoneName: string
    zone: IZone
    subzone: ISubzone
    currentZoneDisplay: string
}

const initialState: IZoneState = {
    zoneName: 'Unknown',
    subzoneName: 'Unknown',
    zone: undefined,
    subzone: undefined,
    currentZoneDisplay: 'Unknown',
}

export const zoneSlice = createSlice({
    name: 'zoneSlice',
    initialState,
    reducers: {
        setZoneInfoReducer: (state, action: PayloadAction<{ zone: IZone, subzone: ISubzone }>) => {
            const currentZoneDisplayString = `${action.payload.zone.zoneDisplayName} ${action.payload.subzone.subzoneDisplayName} zone`
            state.zoneName = action.payload.zone.zoneName
            state.subzoneName = action.payload.subzone.subzoneName
            state.zone = action.payload.zone
            state.subzone = action.payload.subzone
            state.currentZoneDisplay = currentZoneDisplayString
        },
    },
})

export const {
    setZoneInfoReducer,
} = zoneSlice.actions

export default zoneSlice.reducer
